import React from 'react'

// Styles
import styles from "./../StaffManagment.module.css";

const StaffManagmentIncomeBoxs = () => {
    return (
        <div dir="rtl" className={`d-flex justify-content-between flex-wrap align-items-center mt-4 mb-3 py-2 mx-4 px-2`}>
            <div className="w-100 d-flex justify-content-between align-items-center flex-wrap">
                <div className={`${styles.total_staff_financial_income_box}`}>
                    <p className={`mb-0 text-right ${styles.title_staff_financial_income_box}`}> درآمد این هفته </p>
                    <div className="text-left">
                        <span className={`${styles.number_staff_financial_income_box}`}> ۱۰,۰۰۰,۰۰۰ </span>
                        <span className={`${styles.currency_staff_financial_income_box}`}> تومان </span>
                    </div>
                </div>

                <div className={`${styles.total_staff_financial_income_box}`}>
                    <p className={`mb-0 text-right ${styles.title_staff_financial_income_box}`}> درآمد این ماه </p>
                    <div className="text-left">
                        <span className={`${styles.number_staff_financial_income_box}`}> ۱۰,۰۰۰,۰۰۰ </span>
                        <span className={`${styles.currency_staff_financial_income_box}`}> تومان </span>
                    </div>
                </div>

                <div className={`${styles.total_staff_financial_income_box}`}>
                    <p className={`mb-0 text-right ${styles.title_staff_financial_income_box}`}> درآمد کل آذر ملک </p>
                    <div className="text-left">
                        <span className={`${styles.number_staff_financial_income_box}`}> ۱۰,۰۰۰,۰۰۰ </span>
                        <span className={`${styles.currency_staff_financial_income_box}`}> تومان </span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default StaffManagmentIncomeBoxs;